import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { IFeedbackPayload, IFeedbackResponse } from 'app/interfaces/feedback.intefaces';

import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {
  private readonly apiUrl = `${environment.apiBaseUrl}/d2c/chats`;

  constructor(private readonly http: HttpClient) {}

  sendFeedback(
    creatorId: string,
    messageId: number,
    payload: IFeedbackPayload
  ): Observable<IFeedbackResponse> {
    const url = `${this.apiUrl}/${creatorId}/messages/${messageId}/feedback`;
    return this.http.post<IFeedbackResponse>(url, payload);
  }
}
